interface Props {
  title: string | undefined;
}

const PageTitle = ({ title }: Props) => {
  return <h2 className="display-6 m-1 p-1">{title}</h2>;
};

export default PageTitle;
